/**
 * Returns today's date as YYYY-MM-DD in UTC.
 * Daily-streak / check-in resets are aligned to 00:00 UTC so the boundary
 * is identical for every user worldwide and across device timezone changes.
 */
export function getUtcToday(): string {
  const now = new Date();
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}-${String(now.getUTCDate()).padStart(2, '0')}`;
}

/**
 * Returns yesterday's date as YYYY-MM-DD in UTC.
 */
export function getUtcYesterday(): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() - 1);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}
